import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getDefaultUserCommonLimits} from 'src/openapi/admin/apis/DefaultUserLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useDefaultUserCommonLimits = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getDefaultUserCommonLimits({userId}, {signal}),
    ), [userId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
